import infoTemplate from './info.html';

export default angular
  .module('main.locations.edit.tabs.info', [])

  .directive('editLocationInfoTab', () => {
    return {
      restrict: 'E',
      template: infoTemplate,
      scope: {},
      controller: (
        $scope,
        $rootScope,
        $q,
        $filter,
        utils,
        config,
        ToastsService,
        UsersService,
        EditLocationDataProvider,
        PermissionsService,
        I18nService
      ) => {
        const $t = $filter('translate');
        const fallbackLanguage = I18nService.getLocale()?.code || 'en';

        $scope.dataProvider = EditLocationDataProvider.instance;

        // Current location timezone
        $scope.currentTimezoneOffset = moment().tz(moment.tz.guess()).format('Z');

        // Location Test Statuses
        $scope.locationTestStatuses = config.getConfigByKey('locationTestStatuses');
        $scope.locationTypes = config.getLocationTypes();
        $scope.locationSubTypes = config.getLocationSubTypes();

        angular.extend($scope, {
          changeOrg: changeOrg,
          onCancelButtonClick: onCancelButtonClick,
          onSaveButtonClick: onSaveButtonClick,
          copyToClipboard: $rootScope.copyToClipboard
        });

        init();

        function init() {
          $scope.loading = true;
          initWatchers();
          initForm();
          getLanguages();

          $q.all([
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.availableOrganizationsResource.init(),
            $scope.dataProvider.currentOrganizationResource.init(),
            $scope.dataProvider.countriesResource.init(),
            $scope.dataProvider.locationOrganizationResource.init(),
            $scope.dataProvider.locationOrganizationHasFeatureGResource.init()
          ])
            .then(() => {
              initLocationViewModel();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'selectedCountryId',
            'selectedCountry',
            'dataProvider.countriesResource.value'
          ], () => changeCountry());
        }

        function initLocationViewModel() {
          $scope.location = angular.copy($scope.dataProvider.locationResource.value);

          $scope.selectedLocationTypeId = $scope.location.type;
          $scope.selectedLocationSubTypeId = $scope.location.subType || 0;
          $scope.selectedParentId = $scope.location.parentId;

          if ($scope.location.country && $scope.location.country.id) {
            $scope.selectedCountryId = $scope.location.country.id;
            $scope.selectedStateId = $scope.location.state ? $scope.location.state.id : undefined;
          }

          // Test status of location
          $scope.canEditTestFlag = PermissionsService.canIChangeLocationTestFlag($scope.dataProvider.locationResource.value);
          $scope.selectedLocationTestId = $scope.location.test ? 1 : 0;

          // Generate organization name for the field
          $scope.location.organizationName = getOrganizationName($scope.dataProvider.locationOrganizationResource.value);
        }

        function getLanguages() {
          UsersService.getSupportedLanguages()
            .then(data => {
              $scope.locationLanguages = data;
            });
        }

        function initForm() {
          $.fn.form.settings.rules.zipRule = function(value) {
            if (!value) {
              return true;
            }
            if ($scope.selectedCountry && $scope.selectedCountry.zipFormat) {
              return new RegExp($scope.selectedCountry.zipFormat).test(value);
            }
            return true;
          };
          $.fn.form.settings.rules.numberOrEmpty = function(value, n) {
            if (!value) {
              return true;
            }
            let flag = $.fn.form.settings.rules.number(value);
            if (flag) {
              if (n) {
                let arr = n.split('..');
                let min = arr.length >= 1 ? Number(arr[0]) : Number.MIN_VALUE,
                  max = arr.length >= 2 ? Number(arr[1]) : Number.MAX_VALUE,
                  valNum = Number(value);
                return valNum >= min & valNum <= max;
              } else {
                return true;
              }
            }
            return false;
          };

          $('#form-basic-info').form({
            inline: true,
            fields: {
              'name': {
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.locations.name.empty')
                  }
                ]
              },
              'zip': {
                rules: [
                  {
                    type: 'zipRule',
                    prompt: $t('prompt.zip.reg')
                  }
                ]
              },
              'latitude': {
                rules: [
                  {
                    type: 'numberOrEmpty[-90..90]',
                    prompt: $t('prompt.locations.latitude')
                  }
                ]
              },
              'longitude': {
                rules: [
                  {
                    type: 'numberOrEmpty[-180..180]',
                    prompt: $t('prompt.locations.longitude')
                  }
                ]
              }
            }
          });
        }

        /* Change Current Organization on the fly */
        function changeOrg(orgId) {
          if ($scope.loading || !orgId || !$scope.dataProvider.availableOrganizationsResource.value) {
            return;
          }
          let targetOrg = $scope.dataProvider.availableOrganizationsResource.value
            .find(element => orgId === element.id);
          if (targetOrg) {
            $rootScope.$emit('chooseOrganizationEvent', targetOrg, 'locations');
            $scope.dataProvider.currentOrganizationResource.value = targetOrg;
          }
        }

        function getOrganizationName(organization) {
          if (!organization) {
            return;
          }
          let result = organization.name ? organization.name : $t('common.unknownOrganization');
          result += ' / ' + organization.id;
          return result;
        }

        function saveLocation() {
          const locationInfo = {
            location: {
              name: $scope.location.name,
              type: $scope.selectedLocationTypeId,
              addrStreet1: $scope.location.addrStreet1,
              addrStreet2: $scope.location.addrStreet2,
              test: !!$scope.selectedLocationTestId,
              addrCity: $scope.location.addrCity,
              zip: $scope.location.zip,
              utilityAccountNo: $scope.location.utilityAccountNo,
              latitude: $scope.location.latitude || undefined,
              longitude: $scope.location.longitude || undefined,
              language: $scope.location.language || fallbackLanguage,
            }
          };
          if ($scope.canEditTestFlag) {
            locationInfo.location.test = $scope.selectedLocationTestId == 1;
          }

          if ($scope.selectedCountryId) {
            locationInfo.location.country = {
              'id': $scope.selectedCountryId
            };
            if ($scope.selectedStateId) {
              locationInfo.location.state = {
                'id': $scope.selectedStateId
              };
            }
            if ($scope.selectedTimezoneId) {
              locationInfo.location.timezone = {
                'id': $scope.selectedTimezoneId
              };
            }
          }

          return $scope.dataProvider.saveLocationInfo(locationInfo);
        }

        /**
         * Change country and show list of states respectfully
         */
        function changeCountry() {
          if (!$scope.selectedCountry || !$scope.dataProvider.locationResource.value) {
            $scope.states = null;
            $scope.timezones = null;
            return;
          }
          $scope.states = $scope.selectedCountry.states;
          $scope.timezones = $scope.selectedCountry.timezones;

          // Test if initial location TZ is in country TZ list
          if ($scope.dataProvider.locationResource.value.timezone && $scope.timezones && $scope.timezones.length > 0) {
            let testTimezone = $scope.timezones.some(el => el.id === $scope.dataProvider.locationResource.value.timezone.id);
            if (!testTimezone) {
              $scope.timezones.unshift(angular.copy($scope.dataProvider.locationResource.value.timezone));
            }
          }

          let sameCountry = !!($scope.selectedCountry && $scope.dataProvider.locationResource.value.country && $scope.selectedCountry.id === $scope.dataProvider.locationResource.value.country.id);
          let selectedStateId = $scope.states ? $scope.states[0].id : null;
          let selectedTimezoneId = $scope.timezones ? $scope.timezones[0].id : null;

          // Define state
          $scope.selectedStateId = sameCountry && $scope.dataProvider.locationResource.value.state && $scope.dataProvider.locationResource.value.state.id
            ? $scope.dataProvider.locationResource.value.state.id
            : selectedStateId;

          // Define timezone
          $scope.selectedTimezoneId = sameCountry && $scope.dataProvider.locationResource.value.timezone && $scope.dataProvider.locationResource.value.timezone.id
            ? $scope.dataProvider.locationResource.value.timezone.id
            : selectedTimezoneId;

          $scope.timezones = $scope.timezones?.map(tz => {
            return {
              ...tz,
              gmt: getTimezoneGmtString(tz) // Additional field for dropdown
            };
          });
        }

        /**
         * Get GMT string for timezone
         * @param {{id: string, offset: number, ...}} timezone
         * @return {string}
         */
        function getTimezoneGmtString(timezone) {
          let prefix = timezone.offset < 0 ? '-' : '+';
          let offset = timezone.offset || null;
          return $t('datetime.timezone', {
            name: timezone.id,
            hours: prefix + utils.convertMinutes(Math.abs(offset))
          });
        }

        function onCancelButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
        }

        function onSaveButtonClick() {
          if ($scope.loading) {
            return;
          }

          $('#form-basic-info').form('validate form');
          if (!$('#form-basic-info').form('is valid')) {
            return;
          }

          $scope.loading = true;
          $q.all([
            saveLocation(),
          ])
            .then(() => {
              ToastsService.success();
              $scope.loading = false;

              initLocationViewModel();
              // or go
              // $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
            })
            .catch((err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

      }
    };
  })
  .name;
